import React, {useEffect, useState} from 'react';
import {Menu, MenuItem, Sidebar, SubMenu} from "react-pro-sidebar";
import {FaAnchor} from 'react-icons/fa';
import {GiBuoy} from 'react-icons/gi';
import {FiLogOut} from "react-icons/fi";

// import '../dashboard/App.scss';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useCookies} from "react-cookie";
import {NavLink, Route, Routes, useNavigate} from "react-router-dom";
import createPersistentStorage from "./persistent-storage";
import {getCurrentUser, getJobs} from "./api";
import {Job, UserDto} from "./dtos/dtos";
import {FaLocationDot} from "react-icons/fa6";
import JobPage from "./pages/JobPage/JobPage";
import {RiAdminLine} from "react-icons/ri";
import BuoysPage from "./pages/BuoysPage/BuoysPage";

const accessTokenStorage = createPersistentStorage<string>("admin_access_token");

export function App() {
    // const [errorMsg, setErrorMsg] = useState<string>();
    const [user, setUser] = useState<UserDto>();
    const [cookies] = useCookies<string>(['user']);
    const [jobs, setJobs ] = useState<Job[]>([]);
    const [initialized, setInitialized ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setInitialized(true);
    }, [cookies?.username, cookies?.password]);

    useEffect(() => {
        getCurrentUser().then((res: any) => {
            if (res && res.status === 200) {
                setUser(res.data);
            } else {
                // setErrorMsg("Unable to retrieve user data");
            }
        })
    }, []);


    const loadJobs = () => {
        let mounted = true;
        getJobs().then((res: any) => {
            if (mounted) {
                if (res && res.status === 200) {
                    setJobs(res.data);
                } else {
                    // setErrorMsg("Couldn't fetch the jobs. Please reload page");
                }
            }
        })
        return () => { mounted = false };
    }
    useEffect(() => {
        loadJobs();
        // enableSuperAdminView(true);
        // loadUserInfo();
        // loadLogo();
    }, []);

    const logout = () => {
        accessTokenStorage.delete()
        navigate("/login");
    }
    const Home = () => <div><h2>Home Page</h2><p>This is the home page.</p></div>;

    return (
        <div className="adminApp">
            <div className="sidebarArea">
                <div className="sidebarHeader">
                    {/*{ logo && <img  src={`data:image/jpeg;base64,${logo}`} /> }*/}
                    {/*{ userInfo?.userName && <h4>{userInfo.userName}</h4> }*/}
                </div>
                <Sidebar>
                    <Menu>
                        { user?.isGod &&
                            <SubMenu className="submenu" defaultOpen={true} label="Havsans Admin" icon={<RiAdminLine />}>
                                <MenuItem icon={<FaAnchor />} component={<NavLink to="/buoys" />}>Buoys</MenuItem>
                            </SubMenu>
                        }
                        <SubMenu className="submenu" defaultOpen={true} label="Jobs" icon={<GiBuoy />}>
                            { jobs.length > 0 && jobs.map(job =>
                                <MenuItem
                                    key={job.id} icon={<FaLocationDot />}
                                    component={<NavLink to={`/jobs/${job.id}`} />}
                                >
                                    {job.name}
                                </MenuItem>)
                            }
                        </SubMenu>
                    </Menu>
                    <Menu className="borderTop">
                        { <MenuItem icon={<FiLogOut />} onClick={logout}>Logout</MenuItem> }
                    </Menu>
                </Sidebar>
            </div>
            {initialized &&
                <div className="mainArea">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/jobs/:jobId" element={<JobPage />} />
                        <Route path="/buoys" element={<BuoysPage jobs={[]}/>} />
                    </Routes>
                </div>
            }
        </div>
    )
}

